import React from 'react';
import { Form, Input, Row, Col } from 'antd';
import type { FormInstance } from 'antd';
import LookupField from '../../../components/LookupField';
import { lookupApi } from '../../../services/lookupApi';
import type { LookupNames } from './Tab1BasicInfo';

interface Props {
  form: FormInstance;
  disabled: boolean;
  lookupNames: LookupNames;
  onLookupNameChange: (key: keyof LookupNames, name: string) => void;
}

const Tab4Notes: React.FC<Props> = ({ form, disabled, lookupNames, onLookupNameChange }) => {
  const resolveRemarkName = async (code: string) => {
    if (!code.trim()) { onLookupNameChange('remarkTemplate', ''); return; }
    try {
      const r = await lookupApi.getName('remarkTemplate', code);
      onLookupNameChange('remarkTemplate', r.name || '');
    } catch {
      onLookupNameChange('remarkTemplate', '*查無此代號*');
    }
  };

  return (
    <div style={{ padding: '16px 0' }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item label="備註代號" name="fp210_20">
            <LookupField
              lookupType="remarkTemplate"
              value={form.getFieldValue('fp210_20') || ''}
              onChange={v => form.setFieldsValue({ fp210_20: v })}
              onCodeConfirm={resolveRemarkName}
              disabled={disabled}
              maxLength={4} contractFieldId="fp210_20"
            />
          </Form.Item>
          {lookupNames.remarkTemplate && <span className="lookup-name">{lookupNames.remarkTemplate}</span>}
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item label="備註說明" name="fp210_21">
            <Input.TextArea disabled={disabled} rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default Tab4Notes;
